import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import ClientChevron from "./ClientChevron";
import ClientUserName from "./ClientUserName";
import ClientSubscriptionStatus from "./ClientSubscriptionStatus";
import ClientConversations from "./client-conversations";
import ClientPersonalInfo from "./ClientPersonalInfo";
import ConversationMarker from "./ConversationMarker";
import getKhattabatSelectsStore from "../../../stores/khattabat-stores/selects-store";
import {
  TKhattabatApplicationStatus,
  TVIPKhattabatStatus
} from "../../../Types";
import getCorePersonalStore from "../../../stores/core/core-personal-store";

const Client = withLiteObserverAndTheme<{
  vipKhattabaStatus: TVIPKhattabatStatus;
  alkhattabaUUID: string;
  oneOOneCId: string;
  userUUID: string;
  userID: number;
  userName: string;
  originCountry: string;
  residenceCoutry: string;
  height: number;
  weight: number;
  age: number;
  lastLogin: string;
  marriageType: string;
  unreadOneOOneCMessages: number;
  oneOTwoCounter: number;
  isOneOOneCHiddenByKhattaba: boolean;
  applicationStatus: TKhattabatApplicationStatus;
  isInItroductoryPhase: boolean;
}>((props) => {
  const {
    theme,
    alkhattabaUUID,
    userUUID,
    userID,
    userName,
    originCountry,
    residenceCoutry,
    height,
    weight,
    age,
    lastLogin,
    marriageType,
    unreadOneOOneCMessages,
    oneOTwoCounter,
    isOneOOneCHiddenByKhattaba,
    vipKhattabaStatus,
    applicationStatus,
    oneOOneCId,
    isInItroductoryPhase
  } = props;
  const { colors, unitX } = theme;
  const isMarkedConversation = getKhattabatSelectsStore().isMarkedConversation({
    userID
  });
  const borderColors = isMarkedConversation
    ? colors.all.green
    : colors.all.transparent;
  const isKhattabatVIP = vipKhattabaStatus === "EXPIRED" ? false : true;
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();

  return (
    <ET3Div
      width={1510}
      height={0}
      alignItems={"center"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => { }}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="row"
        justifyContent="space-between"
        alignItems="center"
        withShadow={true}
        width={1510}
        height={80}
        color={colors.all.white}
        style={{
          borderRadius: 30 * unitX,
          overflow: "hidden",
          border: `1px solid ${borderColors}`
        }}
        onClick={() => { }}
      >
        <ConversationMarker
          userID={userID}
          isMarkedConversation={isMarkedConversation}
        />
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={400}
          height={80}
          color={colors.all.white}
          style={{}}
          onClick={() => { }}
        >
          <Et3Margin left={1} top={0} bottom={0} right={1} />
          <ClientUserName userName={userName} userID={userID} />
          {isAiKhattaba ? null : (
            <ClientSubscriptionStatus
              subscriptionStatus={vipKhattabaStatus}
              isInItroductoryPhase={isInItroductoryPhase}
            />
          )}
        </ET3Div>
        {isAiKhattaba ? null : (
          <ClientPersonalInfo
            information={`${oneOTwoCounter}`}
            title={"102 Counter"}
          />
        )}
        <ClientPersonalInfo information={residenceCoutry} title={"Location"} />
        <ClientPersonalInfo information={originCountry} title={"Nationality"} />
        <ClientPersonalInfo information={`${age}`} title={"Age"} />
        <ClientPersonalInfo information={`${height}`} title={"Height"} />
        <ClientPersonalInfo information={`${weight}`} title={"Weight"} />
        <ClientPersonalInfo information={lastLogin} title={"Last Login"} />
        {!isAiKhattaba ? null : (
          <ClientPersonalInfo
            information={applicationStatus}
            title={"Status"}
          />
        )}
        <ClientPersonalInfo information={`${marriageType}`} title={""} />
        <ClientChevron
          alkhattabaUUID={alkhattabaUUID}
          userUUID={userUUID}
          unreadOneOOneCMessages={unreadOneOOneCMessages}
          oneOOneCId={oneOOneCId}
        />
      </ET3Div>

      <Et3Margin top={10} bottom={10} left={0} right={0} />
      <ClientConversations
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        isValidSubscription={isKhattabatVIP}
        unreadOneOOneCMessages={unreadOneOOneCMessages}
        isOneOOneCHiddenByKhattaba={isOneOOneCHiddenByKhattaba}
        clientID={userID}
        oneOOneCId={oneOOneCId}
        applicationStatus={applicationStatus}
      />
      <Et3Margin top={25} bottom={25} left={0} right={0} />
    </ET3Div>
  );
});
export default Client;
